// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
export const ComponentOnThisPageFragmentDoc = `
    fragment componentOnThisPage on ComponentOnThisPage {
  __typename
}
    `;